import mfaAndResetDeliveryOptionsTemplate from "../core/mfaAndResetDeliveryOptionsTemplate";

const loginHelpDeliveryOptionsTemplate = `
<div class="col-md-6 col-md-offset-3 col-sm-8 col-sm-offset-2 registration" data-ng-init="getDeliveryOptions()" data-ng-show="mfa.destination=='mfa'">

    <header class="contained-form-header">
        <h1>
            {{ "loginHelp" | translate }}
            <span class="registration-progress">(2 of 4)</span>
        </h1>
        <p>{{ "loginHelpSelectActivationMethod" | translate }}</p>
    </header>

    <div class="inner-container with-padding with-shadow">
        <form role="form" name="deliveryOptions-form" data-ng-submit="createAndDeliverActivationCodePOST('loginHelp')" novalidate>
            ${mfaAndResetDeliveryOptionsTemplate}
        </form>
     </div><!--/inner-container with-padding with-shadow/-->
</div>
`;
export default loginHelpDeliveryOptionsTemplate;
